import { signalTypeMap } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

import type CountPerSignalType from "../../../models/miscellaneous/CountPerSignalType";
import type SignalTypeWithIcon from "../../../models/view/SignalTypeWithIcon";
import SignalTypeView from "../SignalType/SignalTypeView";

import { StyledSignalTypesList } from "./styles";

type SignalTypesListProps = {
    className?: string;
    selectedSignalType: SignalType;
    signalsCountPerType?: Readonly<CountPerSignalType>;
    signalTypes: readonly SignalTypeWithIcon[];
    onSignalTypeClick(signalType: SignalType): void;
};

const SignalTypesList = (props: SignalTypesListProps) => {
    const {
        className,
        signalsCountPerType = {
            [signalTypeMap.adNetwork]: undefined,
            [signalTypeMap.technology]: undefined,
            [signalTypeMap.traffic]: undefined,
            [signalTypeMap.ecommerce]: undefined,
            [signalTypeMap.news]: undefined,
            [signalTypeMap.intent]: undefined,
            [signalTypeMap.advertiserActivity]: undefined,
            [signalTypeMap.apps]: undefined,
            [signalTypeMap.roleChanges]: undefined,
        },
        selectedSignalType,
        signalTypes,
        onSignalTypeClick,
    } = props;

    return (
        <StyledSignalTypesList
            className={className}
            data-automation="signals-types-list"
        >
            {signalTypes.map((signalTypeWithIcon) => (
                <SignalTypeView
                    iconName={signalTypeWithIcon.icon}
                    isActive={selectedSignalType === signalTypeWithIcon.type}
                    key={signalTypeWithIcon.type}
                    numberOfSignals={signalsCountPerType[signalTypeWithIcon.type]}
                    signalType={signalTypeWithIcon.type}
                    onClick={onSignalTypeClick}
                />
            ))}
        </StyledSignalTypesList>
    );
};

export default SignalTypesList;
